import Draft from 'draft-js';
import { Map } from 'immutable';
import React from 'react';
// import katex from 'katex';

import TeXBlock from './TeXBlock';
import ImageBlock from './ImageBlock';
// import {content} from './data/content';
import { insertTeXBlock } from './modifiers/insertTeXBlock';
import { removeTeXBlock } from './modifiers/removeTeXBlock';
import { stateToHTML } from 'draft-js-export-html';
import "!style!css!draft-js/dist/Draft.css";
import "../../css/components/TeXEditor/teXEditor.css";

import ImageUploader from "../ImageUpload/ImageUploader";

var $ = require('jquery');

var {
  Editor,
  EditorState,
  RichUtils,
  AtomicBlockUtils,
  convertToRaw,
  convertFromRaw,
  Entity
} = Draft;

class StyleButton extends React.Component {
  constructor() {
    super();
    this.onToggle = (e) => {
      e.preventDefault();
      this.props.onToggle(this.props.style);
    };
  }

  render() {
    let className = '';
    if (this.props.active) className += 'active';

    return (
      <button
        className={"btn btn-default " + className}
        dangerouslySetInnerHTML={{ __html: this.props.label }}
        onMouseDown={this.onToggle} />
    );
  }
}

const BLOCK_TYPES = [
  { label: 'H1', style: 'header-one' },
  { label: 'H2', style: 'header-two' },
  { label: 'H3', style: 'header-three' },
  { label: 'H4', style: 'header-four' },
  { label: 'H5', style: 'header-five' },
  { label: 'H6', style: 'header-six' },
  { label: '<i class="fa fa-quote-left"></i>', style: 'blockquote' },
  { label: '<i class="fa fa-list-ul"></i>', style: 'unordered-list-item' },
  { label: '<i class="fa fa-list-ol"></i>', style: 'ordered-list-item' },
  { label: '<i class="fa fa-code" aria-hidden="true"></i>', style: 'code-block' },
];

const BlockStyleControls = (props) => {
  const { editorState } = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div className="RichEditor-controls btn-group">
      {BLOCK_TYPES.map((type) =>
        <StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      )}
      <div className="btn dp-inline-block" style={{ padding: 0, border: "none" }}>
        <ImageUploader
          remainModalWhenUpload={true}
          onUploading={props.onUploadingImage}
          onUploadDone={props.uploadImageDone}>
          <button className="btn btn-default" style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>
            <i className="fa fa-picture-o"></i>
          </button>
        </ImageUploader>
      </div>
    </div>
  );
};

var INLINE_STYLES = [
  { label: '<b>B</b>', style: 'BOLD' },
  { label: '<i>I</i>', style: 'ITALIC' },
  { label: '<u>U</u>', style: 'UNDERLINE' }
];

const InlineStyleControls = (props) => {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <div className="RichEditor-controls btn-group">
      {INLINE_STYLES.map(type =>
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      )}
    </div>
  );
};

export default class TeXEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: this.props.initialContent ? EditorState.createWithContent(convertFromRaw(this.props.initialContent)) : EditorState.createEmpty(),
      liveTeXEdits: Map(),
    };

    this._forceRenderWithContent = (content) => {
      // if (!content) return;
      this.setState({
        editorState: content ? EditorState.createWithContent(convertFromRaw(content)) : EditorState.createEmpty()
      })
    }

    this._blockRenderer = (block) => {
      if (block.getType() === 'atomic') {
        var entityType = Entity.get(block.getEntityAt(0)).getType();
        if (entityType === 'TeX') {
          return {
            component: TeXBlock,
            editable: false,
            props: {
              onStartEdit: (blockKey) => {
                var { liveTeXEdits } = this.state;
                this.setState({ liveTeXEdits: liveTeXEdits.set(blockKey, true) });
              },
              onFinishEdit: (blockKey) => {
                var { liveTeXEdits } = this.state;
                this.setState({ liveTeXEdits: liveTeXEdits.remove(blockKey) });
              },
              onRemove: (blockKey) => this._removeTeX(blockKey),
            },
          };
        } else if (entityType === 'image') {
          return {
            component: ImageBlock,
            editable: false,
            props: {
              onResizeImage: (dimension) => {
                var entityKey = block.getEntityAt(0);
                Entity.mergeData(entityKey, { dimension: dimension });
              }
            }
          };
        }
      }
      return null;
    };

    this._focus = () => this.refs.editor.focus();

    this._onChange = (editorState) => {
      this.setState({ editorState }, () => {
        if (this.props.onUpdateContent && typeof this.props.onUpdateContent === 'function') {
          const content = this.state.editorState.getCurrentContent(),
            rawContent = convertToRaw(content);
          var HTMLContent = this.convertRawContent2HTML(rawContent);
          this.props.onUpdateContent(HTMLContent, rawContent);
        }
      })
    }

    this._handleKeyCommand = command => {
      var { editorState } = this.state;
      var newState = RichUtils.handleKeyCommand(editorState, command);
      if (newState) {
        this._onChange(newState);
        return true;
      }
      return false;
    };

    this._removeTeX = (blockKey) => {
      var { editorState, liveTeXEdits } = this.state;
      this.setState({
        liveTeXEdits: liveTeXEdits.remove(blockKey),
        editorState: removeTeXBlock(editorState, blockKey),
      });
    };

    this._insertTeX = () => {
      this.setState({
        liveTeXEdits: Map(),
        editorState: insertTeXBlock(this.state.editorState),
      });
    };

    this._logContent = () => {
      const content = this.state.editorState.getCurrentContent();
      var rawContent = convertToRaw(content);
      console.log(rawContent);
      // this.convertRawContent2HTML(rawContent);
    }

    this.convertRawContent2HTML = (rawContent) => {
      var blocks = rawContent.blocks,
        entityMap = rawContent.entityMap;
      var content = '',
        contentAsArray = [];
      for (var i = 0; i < blocks.length; i++) {
        var block = blocks[i];
        var virtualRawContent = {
          blocks: [block],
          entityMap: {}
        }
        var isTeX = false,
          isImage = false;
        if (block.entityRanges.length > 0) {
          for (var j = 0; j < block.entityRanges.length; j++) {
            var key = block.entityRanges[j].key;
            virtualRawContent.entityMap[key] = entityMap[key];
            if (entityMap[key].type === 'TeX') isTeX = true;
            if (entityMap[key].type === 'image') isImage = true;
          }
        }
        if (block.type === 'atomic') {
          if (isTeX) {
            var DOMDataOffsetKey = block.key + "-0-0",
              TeXDom = $('*[data-offset-key="' + DOMDataOffsetKey + '"]');
            contentAsArray.push(TeXDom.html());
          }
          else if (isImage) {
            // Doesn't support inline image -> entityRanges always has <= 1 element
            var key = block.entityRanges[0].key;
            var entity = virtualRawContent.entityMap[key];
            var html = "";
            if (entity.data.dimension && entity.data.dimension.width && entity.data.dimension.height) {
              html = "<figure><img src='" + entity.data.src + "' width='" + entity.data.dimension.width + "' height='" + entity.data.dimension.height + "'/></figure>";
            } else {
              html = "<figure><img src='" + entity.data.src + "' /></figure>";
            }
            contentAsArray.push(html);
          }
        } else {
          var contentState = convertFromRaw(virtualRawContent);
          contentAsArray.push(stateToHTML(contentState));
        }
      }
      content = contentAsArray.join("");
      return content;
    }

    this._toggleBlockType = (blockType) => {
      this._onChange(
        RichUtils.toggleBlockType(
          this.state.editorState,
          blockType
        )
      );
    }

    this._toggleInlineStyle = (inlineStyle) => {
      this._onChange(
        RichUtils.toggleInlineStyle(
          this.state.editorState,
          inlineStyle
        )
      );
    }

    this._onUploadingImage = () => {
    }

    this._uploadImageDone = (response) => {
      const { editorState } = this.state;
      const entityKey = Entity.create('image', 'IMMUTABLE', { src: response.url })

      this.setState({
        editorState: AtomicBlockUtils.insertAtomicBlock(
          editorState,
          entityKey,
          ' '
        ),
        showURLInput: false,
        urlValue: '',
      }, () => {
        setTimeout(() => this._focus(), 0);
      });
    }
  }

  /**
   * While editing TeX, set the Draft editor to read-only. This allows us to
   * have a textarea within the DOM.
   */
  render() {
    return (
      <div className="TexEditor-container">
        <div className="TeXEditor-root">
          <div className="TeXEditor-toolbar">
            <BlockStyleControls
              editorState={this.state.editorState}
              onToggle={this._toggleBlockType}
              onUploadingImage={this._onUploadingImage}
              uploadImageDone={this._uploadImageDone}
            />
            <InlineStyleControls
              editorState={this.state.editorState}
              onToggle={this._toggleInlineStyle}
            />
            <button className="btn btn-default" onClick={this._insertTeX}>Add Equation</button>
          </div>
          <div className="TeXEditor-editor">
            <Editor
              blockRendererFn={this._blockRenderer}
              editorState={this.state.editorState}
              handleKeyCommand={this._handleKeyCommand}
              onChange={this._onChange}
              placeholder={this.props.placeholder || "Start a document..."}
              readOnly={this.state.liveTeXEdits.count()}
              ref="editor"
              spellCheck={true}
            />
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/TeXEditor/TeXEditor.js
 **/